import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Branch, Customer } from '@pos-app/data';
import { Observable, Subject } from 'rxjs';
import { ApiService, ConfigService, DialogService, ElectronService } from '../../services';
import { ClipboardService } from 'ngx-clipboard';
import { ToastrService } from 'ngx-toastr';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { CoreUiPartialState } from '../../+state/core-ui/core-ui.reducer';
import { getHasActiveOrder, getHasLoadedGiftCards, getIsIncompleteOrder, getParkedOrderListLength } from '../../+state/core-ui/core-ui.selectors';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'central-app-impersonate-partner',
  templateUrl: './impersonate-partner.component.html',
  styleUrls: ['./impersonate-partner.component.scss'],
})
export class ImpersonatePartnerComponent implements OnInit, AfterViewInit {
  @ViewChild('content') modalBox: any;
  @Input() isExternalUser: boolean;
  @Input() customerDetails: any;
  @Output() closeModal = new EventEmitter<void>();
  unSubscribe$ = new Subject<void>();

  isLoading: boolean;
  isElectron: boolean;

  defaultBranch$: Observable<Branch>;
  selectedCustomer: Customer;
  selectedCustomerName: string;
  preSelectedCustomerNumber = false;
  showResultUserSearchTable: boolean = false;
  isIncompleteOrder: boolean;
  hasLoadedGiftCards: boolean;
  hasActiveOrder: boolean;
  hasParkedOrder: boolean;
  showBranchModal: boolean;

  constructor(
    private modalService: NgbModal,
    private apiService: ApiService,
    private clipboardService: ClipboardService,
    private configService: ConfigService,
    private electronService: ElectronService,
    private dialogService: DialogService,
    private toastr: ToastrService,
    private store: Store<CoreUiPartialState>
  ) {}

  ngOnInit() {
    this.isElectron = this.configService.AppConfig.isElectron;
    // Gather all required values from the store before running switchBranch
    const observables = [
      this.store.select(getIsIncompleteOrder).pipe(take(1)),
      this.store.select(getHasLoadedGiftCards).pipe(take(1)),
      this.store.select(getHasActiveOrder).pipe(take(1)),
      this.store.select(getParkedOrderListLength).pipe(take(1)),
    ];

    // Use forkJoin to wait for all values

    forkJoin(observables).subscribe(([isIncompleteOrder, hasLoadedGiftCards, hasActiveOrder, parkedOrderLength]) => {
      this.isIncompleteOrder = !!isIncompleteOrder;
      this.hasLoadedGiftCards = !!hasLoadedGiftCards;
      this.hasActiveOrder = !!hasActiveOrder;
      this.hasParkedOrder = typeof parkedOrderLength === 'number' ? parkedOrderLength > 0 : !!parkedOrderLength;
      this.switchBranch();
    });
  }

  ngAfterViewInit(): void {
    if (this.showBranchModal) {
      this.modalService.open(this.modalBox, { backdrop: 'static', size: 'lg' });
    }
  }
  switchBranch() {
    this.store.pipe(select(getParkedOrderListLength), takeUntil(this.unSubscribe$)).subscribe((length) => {
      if (length > 0) {
        this.hasParkedOrder = true;
      }
    });

    if (this.isIncompleteOrder || this.hasLoadedGiftCards || this.isElectron || this.hasActiveOrder || this.hasParkedOrder) {
      this.showBranchModal = false;
      this.dialogService
        .alert(
          `${
            this.hasActiveOrder || this.isIncompleteOrder
              ? 'You must finalise the order before switching branch.'
              : this.hasParkedOrder
              ? 'Close your parked orders and finalise your changes before switching branch.'
              : ' You must close your cash drawer before switching branch.'
          }`,
          this.isIncompleteOrder || this.hasActiveOrder || this.hasParkedOrder
            ? `${this.hasActiveOrder ? `ACTIVE ORDER` : this.isIncompleteOrder ? `INCOMPLETE ORDER` : 'PARKED ORDER'}`
            : 'GIFTCARDS LOADED'
        )
        .subscribe((val) => {
          if (val) {
            this.modalService.dismissAll();
            this.closeModal.emit();
            this.selectedCustomer = null;
          }
        });
    } else {
      this.showBranchModal = true;
    }
  }

  cancel() {
    this.modalService.dismissAll();
    this.closeModal.emit();
    this.selectedCustomer = null;
  }

  submitChangePartner() {
    if (!this.selectedCustomer?.customerNumber) {
      this.toastr.error('Please select a customer to impersonate.');
      return;
    }
    this.isLoading = true;
    this.apiService
      .impersonatePartner({ site: this.selectedCustomer.customerNumber })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe({
      next: () => {
        this.isLoading = false;
        this.toastr.success('Impersonation successful');
        this.modalService.dismissAll();
        this.closeModal.emit();
        this.selectedCustomer = null;
        window.location.reload();
      },
      error: (error) => {
        this.isLoading = false;
        this.toastr.error(error?.ErrorMessage || 'Impersonation failed');
      },
      });
  }

  selectCustomer(e) {
    this.selectedCustomer = e;
    if (this.selectedCustomer) {
    }
  }

  isFocus(e) {
    this.showResultUserSearchTable = true;
    e.target.select();
  }
}
